import { render, staticRenderFns } from "./sSelectTypeCertificationDetail.vue?vue&type=template&id=6a1bb75a"
import script from "./sSelectTypeCertificationDetail.vue?vue&type=script&lang=js"
export * from "./sSelectTypeCertificationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports